import Layout from '@/layout/index.vue'
const route = [{
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  meta: { title: '后台首页', icon: 'el-icon-HomeFilled'},
  children: [
    {
      name:'dashboard',
      path: 'dashboard',
      component: () => import('@/views/dashboard.vue'),
      meta: { title: '控制台', icon: 'el-icon-House', hideClose: true }
    }
  ]
}]

export default route